import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { Contact } from "../components/Contact";
import { FAQ } from "../components/Sections";

import { TAGLINE, COMPANY_CORE_THOUGHT, LEGAL_ENTITY, SOCIAL_LINKS } from "../data";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact NeuraVolt Technology",
  "url": "https://neuravolt.in/contact",
  "mainEntity": {
    "@type": "Organization",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "slogan": TAGLINE,
    "description": COMPANY_CORE_THOUGHT,
    "telephone": "+919202243725",
    "email": "info@neuravolt.in",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "House No 2, Sai Dham Colony, DD Nagar",
      "addressLocality": "Gwalior",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "474005",
      "addressCountry": "IN"
    },
    "sameAs": [
      SOCIAL_LINKS.linkedin,
      SOCIAL_LINKS.linkedin_profile,
      SOCIAL_LINKS.instagram,
      SOCIAL_LINKS.github,
      SOCIAL_LINKS.google_maps,
    ]
  }
};

export default function ContactPage() {
  return (
    <Layout>
      <Seo
        title="Contact Us - Get a Free Consultation"
        description="Contact Neuravolt (VOLTNOVATE SOLUTIONS LLP) for AI development, custom software, web & mobile apps, and enterprise solutions. Book a free consultation. Located in Gwalior, India."
        keywords="contact Neuravolt, free consultation, software development inquiry, AI development consultation, Gwalior software company, VOLTNOVATE SOLUTIONS LLP contact"
        path="/contact"
        jsonLd={jsonLd}
      />
      <PageHero eyebrow="Contact" title="Let's build something great" sub="Book a free consultation. We reply within one business day." />
      <Contact hideEyebrow={true} />
      <FAQ isContactPage={true} hideEyebrow={true} />
    </Layout>
  );
}
